export interface Rewards {
  // Generic
  totalRewardsEarned: number;
  cashback: number;
  referrals: number;
  promotions: number;

  // Investment tire
  investedIntheLast12Months: number;
  investedIntheLast12MonthsPercentage: number;
  currentInvestementTire: InvestementTireType;

  // Referral
  referLink: string;
  referEarnAmount: number;
  referEarnAmountRequirement: number;
}

export interface InvestementTire {
  type: InvestementTireType;
  title: string;
  investToUnlock: number;
  description: string[];
}

export enum InvestementTireType {
  INTRO = 'intro',
  PLUS = 'plus',
  ELITE = 'elite',
}
